'use strict';

import { State } from 'angular-store';
import { Controller } from '@/decorators/ngCtrl';

@Controller
class ContactView {
  constructor() {
    'ngInject';
  }
}

export default ContactView;
